import Vue from 'vue';
import App from './App.vue';
import HeaderNav from '@/components/HeaderNav.vue';
import router from './router';
import store from './store';
import { http } from '@/utils/http';
import { Toast, Dialog, Image as VanImage, Lazyload } from 'vant';
const commonConfig = require('./config/index.js');

Vue.component('HeaderNav', HeaderNav);
Vue.use(Toast); // vant 会自动将Toast挂载到Vue.prototype.$toast
Vue.use(Dialog); // vant 会自动将Dialog挂载到Vue.prototype.$dialog
Vue.use(VanImage);
Vue.use(Lazyload);

Vue.config.productionTip = false;
Vue.prototype.$http = http;
Vue.prototype.$cdn = commonConfig.CDN_URL;

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app');
